import makePlaceholder from './Placeholder'

export default makePlaceholder({
  imageSet: {
    1: require('./images/icon-thumb.png'),
    2: require('./images/icon-thumb@2x.png'),
    3: require('./images/icon-thumb@3x.png'),
  },
})
